import { FP } from "./tokens";

// Shared sx for outlined TextField / Autocomplete / Select inputs across the
// FinancePro filter cards. Keeps height and border colors consistent.
export const fpInputSx = {
  "& .MuiOutlinedInput-root": {
    height: 46,
    minHeight: 46,
    borderRadius: 1.6,
    bgcolor: "#FFFFFF",
    "& fieldset": { borderColor: FP.color.border },
    "&:hover fieldset": { borderColor: FP.color.borderStrong },
    "&.Mui-focused fieldset": { borderColor: FP.color.navy },
  },
  "& .MuiInputLabel-root": { fontSize: "0.86rem" },
};

// Multiline TextField variant — no fixed height so content can grow.
export const fpMultilineInputSx = {
  "& .MuiOutlinedInput-root": {
    height: "auto",
    minHeight: 56,
    alignItems: "flex-start",
    py: 1.25,
    borderRadius: 1.6,
    bgcolor: "#FFFFFF",
    "& fieldset": { borderColor: FP.color.border },
    "&:hover fieldset": { borderColor: FP.color.borderStrong },
    "&.Mui-focused fieldset": { borderColor: FP.color.navy },
  },
  "& .MuiInputLabel-root": { fontSize: "0.86rem" },
};

export default fpInputSx;
